'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MediaIcon = require('../MediaIcon');

var _MediaIcon2 = _interopRequireDefault(_MediaIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClosedMediaPlayer = function ClosedMediaPlayer(_ref) {
  var onClickHandler = _ref.onClickHandler;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-closed-media-player', onClick: onClickHandler },
    _react2.default.createElement(_MediaIcon2.default, null)
  );
};

ClosedMediaPlayer.defaultProps = {
  onClickHandler: null
};

ClosedMediaPlayer.propTypes = {
  onClickHandler: _react.PropTypes.func
};

exports.default = ClosedMediaPlayer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ClosedMediaPlayer/ClosedMediaPlayer.js
// module id = 561
// module chunks = 11